import React from 'react'
import { Form, Typography } from 'antd'
import { isArray } from 'lodash'
import PropTypes from 'prop-types'

import { antFormItemNamePropType } from '../../prop-types'
import {
  formatFormLabel,
  getFormItemLabelAboveConfiguration,
} from '../../utils'

import ImageUpload from './image-upload'

const normalizeFile = e => {
  if (isArray(e)) {
    return e
  }

  return e?.fileList
}

const FormImageUpload = ({
  name,
  label,
  labelAbove,
  showColon,
  rules,
  disabled,
}) => (
  <Form.Item
    labelCol={getFormItemLabelAboveConfiguration(labelAbove)}
    name={name}
    label={
      <Typography.Text>{formatFormLabel(label, showColon)}</Typography.Text>
    }
    valuePropName="fileList"
    getValueFromEvent={normalizeFile}
    rules={rules}
  >
    <ImageUpload disabled={disabled} name={name} />
  </Form.Item>
)

FormImageUpload.propTypes = {
  name: antFormItemNamePropType.isRequired,
  label: PropTypes.string,
  labelAbove: PropTypes.bool.isRequired,
  rules: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  ),
  showColon: PropTypes.bool,
  disabled: PropTypes.bool,
}

FormImageUpload.defaultProps = {
  label: '',
  rules: undefined,
  showColon: true,
  disabled: false,
}

export default FormImageUpload
